import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;

const LID_H = 1 * IN;
const CASTER_H = 1.5 * IN;
const CASTER_R = 0.75 * IN;
const HANDLE_W = 4 * IN;
const HANDLE_H = 1 * IN;

export function DormLaundryHamperSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const isSide = view === 'left' || view === 'right';
  const w = isSide ? depth : width;

  const lidBottom = LID_H;
  const bodyBottom = height - CASTER_H;

  return (
    <SchematicShell
      width={w}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      {/* Lid bottom line */}
      <Line
        x1={0}
        y1={lidBottom}
        x2={w}
        y2={lidBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Body bottom / caster top */}
      <Line
        x1={0}
        y1={bodyBottom}
        x2={w}
        y2={bodyBottom}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
      {/* Casters — two small circles */}
      {[0.2, 0.8].map((frac, i) => (
        <circle
          key={`caster-${i}`}
          cx={w * frac}
          cy={bodyBottom + CASTER_H / 2}
          r={CASTER_R}
          fill="none"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          vectorEffect="non-scaling-stroke"
        />
      ))}
      {/* Handles on side views */}
      {isSide && (
        <g>
          <Line
            x1={w / 2 - HANDLE_W / 2}
            y1={lidBottom + (bodyBottom - lidBottom) * 0.2}
            x2={w / 2 + HANDLE_W / 2}
            y2={lidBottom + (bodyBottom - lidBottom) * 0.2}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      )}
      {/* Handle cutouts on front view — small rectangles on left and right edges */}
      {!isSide && (
        <g>
          {[0, w - HANDLE_H].map((x, i) => {
            const handleY =
              lidBottom + (bodyBottom - lidBottom) * 0.25 - HANDLE_W / 2;
            return (
              <rect
                key={`handle-${i}`}
                x={x}
                y={handleY}
                width={HANDLE_H}
                height={HANDLE_W}
                fill="none"
                stroke={strokeColor}
                strokeWidth={strokeWidth}
                vectorEffect="non-scaling-stroke"
              />
            );
          })}
        </g>
      )}
    </SchematicShell>
  );
}

DormLaundryHamperSchematic.supportsSideViews = true;
